import { createReducer, on, Action } from '@ngrx/store';
import * as seoActions from '../actions/seo.actions';
import { Header } from '@app/@core/data/models/header.model';

export interface seoState {
  header: Header;
}

const initialState: seoState = {
  header: null,
};

export const seoReducer = createReducer(
  initialState,
  on(seoActions.setHeader, (state, action) => ({
    ...state,
    header: action.payload.header,
  }))
);

export function reducer(state: seoState | undefined, action: Action) {
  return seoReducer(state, action);
}